import { DataType } from '@common/enums/data-type';
import { KnownPropertyTypes } from '@common/enums/known-property-types';
import { IGenericAccessor } from '@common/interfaces/i-generic-accessor';
import { IServiceCollectionScript } from '@common/interfaces/i-service-collection-script';
import { PSTFieldNamesEnum } from '@src/suite/common/data-models/fields/pst-field-names';

import { AbstractServiceRecord } from './abstract-service-record';
import { ServiceCollectionFactory } from './service-collection-factory';
import { ServiceRecord } from './service-record';

const metaData = {
    BackCumeTime: DataType.STRING,
    BackCumeTimeFormatted: DataType.STRING,
    BackOverUnder: DataType.STRING,
    BackTime: DataType.DATE,
    BackTimeFormatted: DataType.STRING,
    Break: DataType.BOOL,
    CBreak: DataType.BOOL,
    CollectionsCollection: DataType.OBJECT,
    CumeTime: DataType.STRING,
    CumeTimeFormatted: DataType.STRING,
    Float: DataType.BOOL,
    FrontOverUnder: DataType.STRING,
    FrontTime: DataType.DATE,
    FrontTimeFormatted: DataType.STRING,
    HasYellowTimingBar: DataType.BOOL,
    IsFrozen: DataType.BOOL,
    IsRowFlashing: DataType.BOOL,
    IsTimingBarSelected: DataType.BOOL,
    NotForBroadcast: DataType.BOOL,
    PageNum: DataType.STRING,
    ScriptOrder: DataType.NUMBER,
};

KnownPropertyTypes.setFor(metaData);

export class ServiceCollectionScript implements IGenericAccessor, IServiceCollectionScript {
    public BackCumeTime?: string;
    public BackCumeTimeFormatted?: string;
    public BackOverUnder?: string;
    public BackTime?: string;
    public BackTimeFormatted?: string;
    public Break?: boolean;
    public CBreak?: boolean;
    public CollectionsCollection?: any;
    public CumeTime?: string;
    public CumeTimeFormatted?: string;
    public Float?: boolean;
    public FrontOverUnder?: string;
    public FrontTime?: string;
    public FrontTimeFormatted?: string;
    public HasYellowTimingBar?: boolean;
    public IsFrozen?: boolean;
    public IsRowFlashing?: boolean;
    public IsTimingBarSelected?: boolean;
    public NotForBroadcast?: boolean;
    public PageNum?: string;
    public RecordPointer: AbstractServiceRecord;
    public ScriptOrder?: number;

    private fieldsToSkip: string[] = [PSTFieldNamesEnum.PageNum];

    public getOwnMetaData(): { [id: string]: number } {
        const objectKeys = Object.keys(this).filter(key => !this.fieldsToSkip.includes(key));
        const ret = {};
        for (const prop of objectKeys) {
            if (metaData[prop]) ret[prop] = metaData[prop];
        }
        return ret;
    }

    public getMetaData(): { [id: string]: number } {
        const ret = this.getOwnMetaData();
        const recordPointerMetaData = this.RecordPointer.getMetaData();

        // merge
        for (const p in recordPointerMetaData) {
            if (!ret[p]) ret[p] = recordPointerMetaData[p];
        }

        return ret;
    }

    public getRawValue(field: string): any {
        if (this.getOwnMetaData()[field]) {
            // console.log("00. " + field + " -> " + this.getOwnMetaData()[field]);
            return this[field];
            // return eval("this." + field);
        }
        return this.RecordPointer.getRawValue(field);
    }

    public instantiateChildren() {
        // TODO: all collections handling
        if (this.RecordPointer.ListData.Type === 3) {
            // Record
            this.RecordPointer = Object.assign(new ServiceRecord(), this.RecordPointer);
        } else {
            // Collection
            this.RecordPointer = Object.assign(ServiceCollectionFactory.newServiceCollectionRecord(), this.RecordPointer);
        }
        this.RecordPointer.instantiateChildren();
    }
}

ServiceCollectionFactory.newServiceCollectionScript = () => new ServiceCollectionScript();
